import type { Router } from 'vue-router';
import { getHostRouter } from '@Src/mfe.config';
import { hostRouteSyncState } from '@Router/hostRouteSyncState';

export const syncRouterToHost = async (router: Router) => {
    const hostRouter = getHostRouter();
    const hostPath = hostRouter?.currentRoute?.value?.fullPath;

    if (!hostPath) {
        return;
    }

    // Singleton router may still resolve a stale route (e.g. wire-instructions) in
    // beforeEach during replace — tell the guard not to call setCurrentMfeRoute yet.
    hostRouteSyncState.isApplyingHostRoute = true;

    try {
        const hostLocation = router.resolve(hostPath);
        if (router.currentRoute.value.fullPath !== hostLocation.fullPath) {
            await router.replace(hostLocation.fullPath);
        }
    } finally {
        hostRouteSyncState.isApplyingHostRoute = false;
    }
};
